var map = {
	"./account.js": "vezx",
	"./layout.js": "0N/T",
	"./menu.js": "uPdz",
	"./page.js": "in+4",
	"./user.js": "rOci"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "vKx/";


//////////////////
// WEBPACK FOOTER
// ./src/store/system/modules nonrecursive \.js$
// module id = vKx/
// module chunks = 90